import type { ThreadMessageDto } from '../../lib/api/openingTasks';

/**
 * Чистые правила показа сообщения переписки по помещению. «От имени партнёра»
 * (владелец 19.10.2026): менеджер добавил сообщение и файлы за партнёра в CRM —
 * сервер ставит ему сторону партнёра, `author.name` — имя менеджера.
 */

/** Сторона пузыря: партнёр (включая «от имени партнёра»), проектировщик (внешний подрядчик, подпись «проектировщик») или куратор. */
export function bubbleSide(m: Pick<ThreadMessageDto, 'author'>): 'partner' | 'curator' | 'designer' {
  if (m.author.side === 'designer') return 'designer';
  return m.author.side === 'partner' ? 'partner' : 'curator';
}

/** «Добавил менеджер <имя> от вашего имени»; имени нет — «Добавил менеджер от вашего имени». */
export function onBehalfSignature(name: string | null | undefined): string {
  const who = (name ?? '').trim();
  return who ? `Добавил менеджер ${who} от вашего имени` : 'Добавил менеджер от вашего имени';
}

/** Подпись «Добавил менеджер <имя> от вашего имени»; у обычных сообщений — null. */
export function onBehalfNote(m: Pick<ThreadMessageDto, 'author'>): string | null {
  return m.author.onBehalf ? onBehalfSignature(m.author.name) : null;
}

/**
 * Плашка над полем ввода в режиме «смотреть от лица партнёра» (владелец 19.10.2026:
 * «и фото, и видео, и проект — из базы знаний; в CRM доступ к заявкам партнёрам не
 * даём»). Менеджер пишет в переписку — сервер запишет сообщение от НАСТОЯЩЕГО
 * пользователя «от имени партнёра», партнёр увидит ту же подпись, что и в ленте.
 * `realName` — настоящий пользователь из /wiki-auth/me (viewAs.realName).
 */
export function viewAsComposerNote(realName: string | null | undefined): string {
  return `Вы смотрите от лица партнёра. Сообщение и файлы уйдут от его имени — партнёр увидит «${onBehalfSignature(realName)}».`;
}
